import styled, { css } from "styled-components";

export const PageBreak = styled.div<{ applyPageBreak: boolean }>`
    ${({ applyPageBreak }) =>
        applyPageBreak &&
        css`
            @media print {
                display: block;
                break-before: page;
            }
        `}
`;
